import { useContext, useState } from 'react';

import useNotification from '@/hooks/notifications';
import useFindErrors from '@/hooks/useFindErrors';

import { ErrorsContext } from '@/context/errorsContext';

import { Button, Col, Modal, Row } from 'antd';
import { useNavigate } from 'react-router-dom';

const style = {
	width: 200,
	padding: '5px 10px',
	borderRadius: '100px'
};

export default function StepButtons ({selector, totalSteps, currentStep, setStep}) {
	const navigate = useNavigate();

	const {/* data, */ process: { edit, loading }, uploadIngest, ingestMedia, setInitialState} = selector();

	const {findErrors} = useFindErrors();
	const {openNotification} = useNotification();
	const { resetErrors } = useContext(ErrorsContext);
	const [showConfirmModal, setShowConfirmModal] = useState(false);

	function handleCancel () {
		if (edit) {
			navigate(-1);
		} else {
			setInitialState();
			resetErrors();
		}
	}

	function hanldeUpload () {
		const {ok, errors} = findErrors();

		if(!ok) {
			openNotification({message: 'Errors in the form!' , description: errors[0], type: 'error'});
		} else {
			/* data.mediaType === 'EPV_PHOTO' ? ingestMedia() : uploadMetadata(); */
			ingestMedia();
			resetErrors();
		}
	}

	function handlePrevious () {
		setStep(currentStep - 1);
	}

	async function handleNext () {
		const {ok, errors} = findErrors();

		if(!ok) {
			openNotification({message: 'Errors in the form!' , description: errors[0], type: 'error'});
		} else {
			/* setShowConfirmModal(true); */
			const isOk = await uploadIngest();

			if (!isOk) return;

			setStep(currentStep + 1);
		}
	}

	function handleConfirm () {
		setStep(currentStep + 1);
		resetErrors();
		setShowConfirmModal(false);
	}

	return (
		<Row justify="center" gutter={[64, 16]}>
			<Modal
				title="Warning!"
				open={showConfirmModal}
				onOk={handleConfirm}
				onCancel={() => setShowConfirmModal(false)}
			>
				<p>Please note that once you proceed, you will not be able to make further changes. Ensure all details are correct before continuing. If no edits are needed and you only need to upload files, you may proceed.</p>
			</Modal>
			<Col>
				<Button onClick={handleCancel} danger type="primary" size='large' style={style}>Cancel</Button>
			</Col>
			{
				currentStep > 0 && (
					<Col>
						<Button onClick={handlePrevious} type="default" size='large' style={style}>Previous</Button>
					</Col>
				)
			}
			{
				currentStep < totalSteps - 1 && (
					<Col>
						<Button
							onClick={handleNext}
							info
							type="primary"
							size='large'
							style={style}
							loading={loading}
						>Save</Button>
					</Col>
				)
			}
			{
				currentStep === totalSteps - 1 && (
					<Col>
						<Button
							onClick={hanldeUpload}
							type="primary"
							size='large'
							style={style}
							loading={loading}
						>Confirm Upload</Button>
					</Col>
				)
			}
		</Row>
	);
}